export default <T>(res: { data: T }) => res.data;
